/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_LoadingInputs */

const en_confirm_loading = /** @type {(inputs: Confirm_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading…`)
};

const he_confirm_loading = /** @type {(inputs: Confirm_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טוען…`)
};

/**
* | output |
* | --- |
* | "Loading…" |
*
* @param {Confirm_LoadingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const confirm_loading = /** @type {((inputs?: Confirm_LoadingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_LoadingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_loading(inputs)
	return he_confirm_loading(inputs)
});